import React from 'react';
import { withTranslation } from 'react-i18next';

import styles from './about-us.module.scss';

/* eslint-disable */
// @ts-ignore
function AboutUs({ t }) {
  return (
    <div className={styles.about} id="AboutUs">
      <div className={styles.aboutTitle}>{t('About us')}</div>

      <div className={styles.aboutContent}>

        <div className={styles.aboutContentFinanceReport}>
          {t('Our financial statements')}
          <a
            className={styles.aboutContentFinanceReportLink}
            href="https://drive.google.com/file/d/1ssqQI_-B5jtsmb5HXqucku4ddRlqGhPj/view?usp=sharing"
            target="_blank"
          >
            2022
          </a>
          <a
            className={styles.aboutContentFinanceReportLink}
            href="https://drive.google.com/file/d/1Dzv5KiCh2QF1P-724-C963GJ5a8Ad_M2/view?usp=sharing"
            target="_blank"
          >
            2023
          </a>
          <a
            className={styles.aboutContentFinanceReportLink}
            href="https://drive.google.com/file/d/1X8Vk2odq7CYIpt8ZK_0n3xEmxLK5QWfX/view?usp=sharing"
            target="_blank"
          >
            2024
          </a>
          <a
            className={styles.aboutContentFinanceReportLink}
            href="https://drive.google.com/file/d/1xwtsItg-J3FYKmNbbw_CGszzK_vZo5U8/view?usp=sharing"
            target="_blank"
          >
            2025
          </a>
        </div>
        <div className={styles.aboutContentItem}>
          <div className={styles.aboutContentItemTitle}>
            {t('Full software')}
            <br />
            {t('development life cycle')}
          </div>
          <div className={styles.aboutContentItemDescription}>
            {t('We will develop your product from idea to implementation and support. Follows the best coding and implementation practices and uses the most effective technologies and resources.')}
          </div>
        </div>

        <div className={styles.aboutContentItem}>
          <div className={styles.aboutContentItemTitle}>{t('Extensive experience in implementing solutions')}</div>
          <div className={styles.aboutContentItemDescription}>
            {t(`Development from scratch of large enterprise solutions - business landing, customer service in branches, web platforms, design system, mobile banking for First Ukrainian International Bank. Implementation of complex integration solutions with major market vendors - Creatio, Corezoid, IBM, Microsoft, AWS, Cisco and others.`)}
          </div>
        </div>

        <div className={styles.aboutContentItem}>
          <div className={styles.aboutContentItemTitle}>
            {t('Flexible')}
            <br />
            {t('product delivery')}
          </div>
          <div className={styles.aboutContentItemDescription}>
            {t('Our specialists are located in different parts of the world, we have been effectively working remotely for more than 3 years using slack/teams/jira and more. The outcome and the value that the customers receive are crucial to us.')}
          </div>
        </div>

      </div>
    </div>
  );
}

export default withTranslation()(AboutUs)
